import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { UiModule } from '@piqet-angular/ui';
import { SharedModule } from '@piqet-angular/shared';
import { LetModule, PushModule } from '@ngrx/component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgChartsModule } from 'ng2-charts';
import { ProjectDetailsRoutingModule } from './project-details-routing.module';
import { ProjectMaterialListComponent } from './project-material-list/project-material-list.component';
import { ProjectReportChartGlanceComponent } from './project-report-chart-glance/project-report-chart-glance.component';
import { ProjectReportChartGlanceV2Component } from './project-report-chart-glance-v2/project-report-chart-glance-v2.component';
import { ProjectReportGenerationComponent } from './project-report-generation/project-report-generation.component';
import { ProjectReportGenerationV2Component } from './project-report-generation-v2/project-report-generation-v2.component';
import { ProjectScenarioConfigurationComponent } from './project-scenario-configuration/project-scenario-configuration.component';
import { ProjectScenarioConsumerComponent } from './project-scenario-consumer/project-scenario-consumer.component';
import { ProjectScenarioEOLComponent } from './project-scenario-eol/project-scenario-eol.component';
import { ProjectScenarioFillDataComponent } from './project-scenario-fill-data/project-scenario-fill-data.component';
import { ProjectScenarioListComponent } from './project-scenario-list/project-scenario-list.component';
import { ProjectScenarioManufacturingComponent } from './project-scenario-manufacturing/project-scenario-manufacturing.component';
import { ProjectScenarioRetailComponent } from './project-scenario-retail/project-scenario-retail.component';
import { ProjectScenarioWholesaleDataComponent } from './project-scenario-wholesale-data/project-scenario-wholesale-data.component';
import { ProjectDetailsContentComponent } from './project-details-content/project-details-content.component';
import { ProjectDetailsSidebarComponent } from './project-details-sidebar/project-details-sidebar.component';
import { ProjectPackConversionComponent } from './project-pack-conversion/project-pack-conversion.component';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { InputsModule } from '@progress/kendo-angular-inputs';
// import { ChartsModule } from '@progress/kendo-angular-charts';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { ProjectDetailReportComponent } from './project-detail-report/project-detail-report.component';
import { ReportProgressComponent } from './project-detail-report/report-progress/report-progress.component';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { JoyrideModule } from 'ngx-joyride';
import { ProductLossComponent } from './product-loss/product-loss.component';
import { ReportInterpretationComponent } from './report-interpretation/report-interpretation.component';
import { TextPreviewComponent } from '../common/text-preview/text-preview.component';
@NgModule({
  declarations: [
    ProjectDetailsSidebarComponent,
    ProjectDetailsContentComponent,
    ProjectScenarioConfigurationComponent,
    ProjectScenarioListComponent,
    ProjectMaterialListComponent,
    ProjectPackConversionComponent,
    ProjectScenarioRetailComponent,
    ProjectScenarioConsumerComponent,
    ProjectScenarioWholesaleDataComponent,
    ProjectScenarioFillDataComponent,
    ProjectScenarioManufacturingComponent,
    ProjectScenarioEOLComponent,
    ProjectReportChartGlanceComponent,
    ProjectReportChartGlanceV2Component,
    ProjectReportGenerationComponent,
    ProjectReportGenerationV2Component,
    ProjectDetailReportComponent,
    ReportProgressComponent,
    ProductLossComponent,
    ReportInterpretationComponent,
    TextPreviewComponent,
  ],
  imports: [
    CommonModule,
    LetModule,
    PushModule,
    NgSelectModule,
    UiModule,
    SharedModule,
    NgOptionHighlightModule,
    FormsModule,
    ProjectDetailsRoutingModule,
    ReactiveFormsModule,
    NgxSliderModule,
    NgxSpinnerModule,
    NgChartsModule,
    GaugesModule,
    InputsModule,
    PDFExportModule,
    // ChartsModule,
    ButtonsModule,
    JoyrideModule.forChild(),
  ],
  exports: [
    ProjectDetailsSidebarComponent,
    ProjectDetailsContentComponent,
    FormsModule,
    ReactiveFormsModule,
    TextPreviewComponent,
  ],
  providers: [TitleCasePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectDetailsModule {}
